export default __webpack_public_path__ + "static/force-usa_medium_2-4c584bde771e0fd997ac99e35b64b88e.webp";